export const userActivityLogActionTypes = {
    SET_USER_ACTIVITY_LOGS: 'SET_USER_ACTIVITY_LOGS',
    SET_USER_ACTIVITY_LOG_STATISTICS: 'SET_USER_ACTIVITY_LOG_STATISTICS',
    SET_LOADING: 'SET_USER_ACTIVITY_LOG_LOADING',
    SET_ERROR: 'SET_USER_ACTIVITY_LOG_ERROR',
};
